import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    printing: false,
    lastUpdate: null,
  }),
  actions: {
    setLastUpdate (data) { this.lastUpdate = data },
    setPrinting (printing) { this.printing = printing },
  }
})
